module.exports = __webpack_public_path__ + "static/media/bandeira_visa.2fabd8fa.svg";